/**
 * @generated SignedSource<<21cbfc5fb467c369aebe2fb0c79d25a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddHideVisibilityTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  rootNodeId: string;
};
export type VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation$variables = {
  input: AddHideVisibilityTreeConfigInput;
};
export type VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addHideVisibilityTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"VisibilityTreeConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation = {
  response: VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation$data;
  variables: VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dateTime",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddHideVisibilityTreeConfigPayload",
                "kind": "LinkedField",
                "name": "addHideVisibilityTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "VisibilityTreeConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddHideVisibilityTreeConfigPayload",
                "kind": "LinkedField",
                "name": "addHideVisibilityTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "visibilityConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isVisibilityTreeConfig"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "NotAfterDateTimeVisibilityTreeConfig",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "AfterDateTimeVisibilityTreeConfig",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fachrichtungen",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "OnlyFachrichtungenVisibilityTreeConfig",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v4/*: any*/),
                                    "type": "OnlySpecificPermissionsVisibilityTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "898ee7b672bb8b926d33170af8484bbc",
    "id": null,
    "metadata": {},
    "name": "VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation",
    "operationKind": "mutation",
    "text": "mutation VisibilityTreeConfigEditor_AddHideVisibilityConfigMutation(\n  $input: AddHideVisibilityTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      addHideVisibilityTreeConfig(input: $input) {\n        rootNode {\n          ...VisibilityTreeConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment AfterDateTimeVisibilityConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment AfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment on NotAfterDateTimeVisibilityTreeConfig {\n  id\n  dateTime\n  configType\n}\n\nfragment NotAfterDateTimeVisibilityConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment on NotAfterDateTimeVisibilityTreeConfig {\n  id\n  dateTime\n  configType\n}\n\nfragment OnlySpecializationVisibilityConfigForm_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      visibilityConfigs {\n        __typename\n        ...OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment\n        id\n      }\n    }\n  }\n}\n\nfragment OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment on VisibilityTreeConfig {\n  __isVisibilityTreeConfig: __typename\n  ... on OnlyFachrichtungenVisibilityTreeConfig {\n    id\n    configType\n    fachrichtungen\n  }\n}\n\nfragment OnlySpecificPermissionsVisibilityConfigForm_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      visibilityConfigs {\n        __typename\n        ...OnlySpecificPermissionsVisibilityConfigForm_VisibilityTreeConfigFragment\n        id\n      }\n    }\n  }\n}\n\nfragment OnlySpecificPermissionsVisibilityConfigForm_VisibilityTreeConfigFragment on VisibilityTreeConfig {\n  __isVisibilityTreeConfig: __typename\n  ... on OnlySpecificPermissionsVisibilityTreeConfig {\n    id\n    configType\n    dateTime\n  }\n}\n\nfragment ProjectExtendVisibilityConfigEditDialogs_TreeNodeFragment on TreeNode {\n  ...OnlySpecializationVisibilityConfigForm_TreeNodeFragment\n  ...OnlySpecificPermissionsVisibilityConfigForm_TreeNodeFragment\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      visibilityConfigs {\n        __typename\n        ... on OnlyIfTreeStateOrAdminVisibilityTreeConfig {\n          id\n          configType\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectExtendVisibilityConfigEditDialogs_VisibilityTreeConfigFragment on VisibilityTreeConfig {\n  __isVisibilityTreeConfig: __typename\n  configType\n  ...OnlySpecializationVisibilityConfigForm_VisibilityTreeConfigFragment\n  ...OnlySpecificPermissionsVisibilityConfigForm_VisibilityTreeConfigFragment\n}\n\nfragment VisibilityTreeConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      visibilityConfigs {\n        __typename\n        id\n        configType\n        ... on NotAfterDateTimeVisibilityTreeConfig {\n          dateTime\n        }\n        ... on AfterDateTimeVisibilityTreeConfig {\n          dateTime\n        }\n        ...NotAfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment\n        ...AfterDateTimeVisibilityConfigForm_VisibilityTreeConfigFragment\n        ...ProjectExtendVisibilityConfigEditDialogs_VisibilityTreeConfigFragment\n      }\n    }\n  }\n  ...NotAfterDateTimeVisibilityConfigForm_TreeNodeFragment\n  ...AfterDateTimeVisibilityConfigForm_TreeNodeFragment\n  ...ProjectExtendVisibilityConfigEditDialogs_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "cbb81cb6057dd29975d99160041cc7de";

export default node;
